import React, { useState, useEffect } from 'react';
import { CreditCard, CheckCircle, AlertCircle, Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';

const StripeConnectBanner = ({ user }) => {
  const navigate = useNavigate();
  const [hasConnectedAccount, setHasConnectedAccount] = useState(null);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    checkStripeConnectStatus();
  }, [user]);

  const checkStripeConnectStatus = async () => {
    if (!user) {
      setIsChecking(false);
      return;
    }

    try {
      setIsChecking(true);
      const response = await api.get('/stripe-connect/account-status');
      
      console.log('StripeConnectBanner: Account status response:', response.data);
      
      if (response.data.success) {
        // ✅ FIX: Backend never returns hasConnectedAccount field!
        // Check if account exists AND charges are enabled
        const isConnected = response.data.account && 
                           response.data.account.chargesEnabled === true &&
                           response.data.account.payoutsEnabled === true;
        setHasConnectedAccount(isConnected);
        console.log('StripeConnectBanner: Has connected account:', isConnected);
      } else {
        setHasConnectedAccount(false);
      }
    } catch (error) {
      console.error('StripeConnectBanner: Error checking Stripe status:', error);
      // If error, assume not connected (safe default)
      setHasConnectedAccount(false);
    } finally {
      setIsChecking(false);
    }
  };

  const handleGoToSettings = () => {
    navigate('/portal/settings?section=stripe');
  };

  // Don't show while checking
  if (isChecking) {
    return null;
  }

  // Don't show for additional users - they use the main user's Stripe account
  if (user?.role === 'additional_user') {
    console.log('StripeConnectBanner: Additional user - hiding banner (uses main user Stripe account)');
    return null;
  }

  // Don't show if already connected
  if (hasConnectedAccount === true) {
    console.log('StripeConnectBanner: Account connected, hiding banner');
    return null;
  }

  return (
    <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <CreditCard className="h-5 w-5 text-blue-400" />
        </div>
        <div className="ml-3 flex-1">
          <div>
            <h3 className="text-sm font-medium text-blue-800">
              💳 Stripe Connect Required to Send Invoices & Receive Payments
            </h3>
            <div className="mt-2 text-sm text-blue-700">
              <p>
                <strong>You cannot send invoices until you connect your Stripe account.</strong> This is required to receive payments from your customers.
              </p>
              <p className="mt-2">
                The setup is secure, free, and takes just 2-3 minutes.
              </p>
            </div>
          </div>
          
          <div className="mt-4">
            <button
              onClick={handleGoToSettings}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors shadow-sm"
            >
              <Settings className="h-4 w-4 mr-2" />
              Connect Stripe in Settings
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StripeConnectBanner;

